/*
 * Copyright © 2018-2025, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import React, { useEffect, useState } from "react";
import moment from "moment";
import { strings } from "../../../common/Strings/Strings";
import MonthlyDaySelect from "./MonthlyDaySelect";
import { ChevronRight } from "../../../common/Icons/ChevronRight";
import { ChevronLeft } from "../../../common/Icons/ChevronLeft";
import Button from "../../../components/Button";
import { momentDateFormat } from "../calendarConfig";

interface Props {
  selectedDay: string;
  setSelectedDay(newDay: string): void;
}

const YearView: React.FC<Props> = (props: Props) => {
  const { selectedDay, setSelectedDay } = props;
  const [year, setYear] = useState<number>(moment(selectedDay).year());
  const months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

  const nextYear = () => {
    if (year + 1 < 2100) {
      setYear(year + 1);
    }
  };

  const previousYear = () => {
    if (year - 1 > 1900) {
      setYear(year - 1);
    }
  };

  useEffect(() =>{
    if(moment(selectedDay).year() !== year){
      setYear(moment(selectedDay).year());
    }
  }, [selectedDay]);

  return (
    <div className="bg-white dark:bg-gray-800 p-6">
      <div className="hidden lg:flex space-x-4 pb-4 items-center">
        <Button
          variant="link"
          onClick={() => {
            setSelectedDay(moment().format(momentDateFormat));
            if(moment().year() !== year){
              setYear(moment().year());
            }
          }}
        >
          <span className="tw-link-tercier">{strings.today}</span>
        </Button>
        <Button variant="icon" onClick={previousYear}>
          <ChevronLeft />
        </Button>
        <Button variant="icon" onClick={nextYear}>
          <ChevronRight />
        </Button>
        <div className="font-bold">{year}</div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4">
        {months.map((value, index) => {
          const monthDate = moment(selectedDay).month(value).year(year);

          return (
            <div key={index}>
              <div className="text-sm">{monthDate.format("MMMM")}</div>
              <MonthlyDaySelect
                inputDate={monthDate.format("YYYY-MM-DD")}
                localSelectedDay={selectedDay}
                setLocalSelectedDay={(newDate: string) => {
                  setSelectedDay(newDate);
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default YearView;
